// extracted by mini-css-extract-plugin
module.exports = {"socButtonTg":"SocialLinks_socButtonTg__2yYMF","socButton":"SocialLinks_socButton__3-cOT","wrapper":"SocialLinks_wrapper__2LjB8"};